import { render, staticRenderFns } from "./Appearance.vue?vue&type=template&id=19bd7ba5&"
import script from "./Appearance.vue?vue&type=script&lang=js&"
export * from "./Appearance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports